<template>
  <v-row justify="center">
    <v-dialog class="restoreItemModal" v-model="open" width="600px">
      <v-scroll-x-transition mode="out-in" hide-on-leave>
        <v-card v-if="showMainModalContent">
          <v-toolbar elevation="0">
            <v-toolbar-title class="pl-2 restoreModalTitle">
              <span v-if="isCallback">
                {{ $t('message.pages.restoreModal.title') }}
              </span>
              <span v-else>
                {{
                  items.length > 1
                    ? $t('message.pages.restoreModal.subtitleTextPlural')
                    : $t('message.pages.restoreModal.subtitleText')
                }}
              </span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon @click="handleClose()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text class="pl-7 pr-5 py-0">
            <v-container class="pl-0">
              <v-row no-gutters>
                <v-col cols="12" class="mb-2 restoreModalDescription">
                  <span v-if="!isCallback">
                    {{
                      items.length > 1
                        ? $t('message.pages.restoreModal.bodyText1Plural')
                        : $t('message.pages.restoreModal.bodyText1')
                    }}?
                  </span>
                  <span v-else>
                    {{ $t('message.pages.restoreModal.bodyText2') }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-8 pb-6 pt-6">
            <v-spacer></v-spacer>
            <base-btn
              class="mr-2"
              type="tertiary"
              :disabled="isFetching"
              @click="handleClose"
            >
              {{ $t('message.cancel') }}
            </base-btn>
            <base-btn
              type="primary"
              :loading="isFetching"
              :disabled="isFetching"
              @click="handleRestoreItems"
            >
              {{
                items.length > 1
                  ? $t('message.pages.restoreModal.subtitleTextPlural')
                  : $t('message.pages.restoreModal.subtitleText')
              }}
            </base-btn>
          </v-card-actions>
        </v-card>
      </v-scroll-x-transition>
      <!-- <v-dialog
        v-model="selectFolder"
        scrollable
        persistent
        max-width="1050"
        transition="slide-x-transition"
      >
        <v-card>
          <v-toolbar elevation="0">
            <v-toolbar-title class="text-subtitle">
              <v-btn
                color="primary"
                icon
                @click="handleBackToMainContent"
              >
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <span style="font-size: 17px;">Escolha uma Pasta para restaurar seu arquivo:</span>
            </v-toolbar-title>
          </v-toolbar>
          <v-toolbar
            elevation="0"
            class="mx-5"
          >
            <template v-if="isNamesTooBig">
              <v-menu
                offset-y
                max-width="250"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon
                      class="elevation-0"
                      color="primary"
                    >mdi-package-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in reducedBreadcrumbArray"
                    :key="index"
                    @click="handleBackTo(item)"
                    dense
                  >
                    <v-list-item-title :title="item.id ? item.name : 'Panda'">
                      <span class="subtitle-2">
                        <v-icon
                          class="mr-2 pb-1"
                          color="primary"
                        >
                          {{item.id ? 'mdi-folder-outline' : 'mdi-home' }}
                        </v-icon>
                        {{item.id ? item.name : 'Panda'}}
                      </span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-icon>mdi-chevron-right</v-icon>
              <button
                v-if="!selectedFolder"
                type="button"
                class="primary--text"
                @click="handleBackTo(lastBreadcrumbItem)"
              >
                <span class="breadcrumbTexts primary--text">
                  {{lastBreadcrumbItem.id ? lastBreadcrumbItem.name : 'Panda'}}
                </span>
              </button>
              <button
                v-else
                type="button"
                class="primary--text"
              >
                <span class="breadcrumbTexts primary--text">
                  {{selectedFolder.name}}
                </span>
              </button>
            </template>
            <template v-else>
              <small
                v-for="(item, i) in breadcrumbArray"
                :key="i"
              >
                <button
                  type="button"
                  class="primary--text"
                  @click="handleBackTo(item)"
                >
                  <span class="breadcrumbTexts primary--text">
                    {{item.id ? item.name : 'Panda'}}
                    <v-icon v-if="i<breadcrumbArray.length-1">mdi-chevron-right</v-icon>
                  </span>
                </button>
              </small>
              <small>
                <v-icon v-if="!!selectedFolder">mdi-chevron-right</v-icon>
                <button
                  v-if="!!selectedFolder"
                  type="button"
                  class="primary--text"
                >
                  <span class="breadcrumbTexts primary--text">
                    {{selectedFolder.name}}
                  </span>
                </button>
              </small>
            </template>
          </v-toolbar>
          <v-card-text style="height: 352px;">
            <v-list
              v-if="toBeSelectedFolders.length"
              dense
            >
              <v-list-item-group v-model="selectedFolder">
                <v-list-item
                  v-for="folder in toBeSelectedFolders"
                  :key="folder.id"
                  :value="folder"
                  @click="handleRowClick(folder)"
                >
                  <v-list-item-icon>
                    <v-icon v-text="'mdi-folder-outline'"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title v-text="folder.name"></v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action
                    v-if="checkIfHasChildren(folder)"
                    class="my-0 py-0"
                  >
                    <v-icon color="black">mdi-arrow-right</v-icon>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-row
              v-else
              no-gutters
              align="center"
              justify="center"
            >
              <span class="mt-8">{{$t('message.noFoldersFound')}}</span>
            </v-row>
          </v-card-text>
          <v-card-actions
            class="px-8 py-4"
            style="justify-content: flex-end;"
          >
            <v-menu
              v-model="newFolderMenu"
              :close-on-content-click="false"
              offset-x
            >
              <template v-slot:activator="{ on, attrs }">
                <button
                  v-bind="attrs"
                  v-on="on"
                  type="button"
                  class="primary--text"
                >
                  <span class="breadcrumbTexts primary--text">
                    {{$t('message.newFolder')}}
                  </span>
                </button>
              </template>

              <v-card width="300">
                <v-row
                  no-gutters
                  class="mx-4"
                >
                  <v-col
                    cols="12"
                    class="mt-2"
                  >
                    <v-icon color="primary">mdi-folder-plus</v-icon>
                    <span class="ml-2">{{ $t('message.newFolder') }}</span>
                  </v-col>
                  <v-col
                    cols="12"
                    class="mt-3"
                  >
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                      v-on:submit.prevent
                    >
                      <v-text-field
                        v-model="newFolder.name"
                        autofocus
                        dense
                        :placeholder="$t('message.name')"
                        :rules="[rules.required, rules.maxLength, rules.minLength]"
                        required
                        counter="50"
                        color="primary"
                        outlined
                        @keyup.enter="handleNewFolder"
                      ></v-text-field>
                    </v-form>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    text
                    :disabled="fetchingNewFolder"
                    @click="newFolderMenu = false"
                  >
                    {{ $t('message.cancel') }}
                  </v-btn>
                  <v-btn
                    small
                    color="primary"
                    text
                    :loading="fetchingNewFolder"
                    :disabled="fetchingNewFolder || !valid || newFolder.name.length < 3"
                    @click="handleNewFolder"
                  >
                    {{ $t('message.create') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <v-spacer></v-spacer>
            <v-btn
              class="px-6"
              text
              :disabled="isFetching"
              @click="handleBackToMainContent"
            >
              Voltar
            </v-btn>
            <v-btn
              color="primary"
              @click="handleConfirmFolder"
            >
              <span class="px-5">Confirmar</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-dialog>
  </v-row>
</template>

<script>
import videosApi from '@/services/videosApi'
import foldersApi from '@/services/foldersApi'
import { mapActions, mapMutations, mapState } from 'vuex'
import i18n from '@/translations/lang'

export default {
  name: 'RestoreModal',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    items: [],
    isCallback: false,
    folder: {
      id: null,
      name: '',
    },
    showMainModalContent: true,
    selectFolder: false,
    movedItems: [],
    breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
    selectedFolder: null,
    lastFolder: {
      name: '',
      id: null,
      parent_folder_id: null,
    },
    newFolderMenu: false,
    newFolder: {
      name: '',
    },
    valid: false,
    rules: {
      required: (v) => (v && !!v) || i18n.t('message.requiredField'),
      maxLength: (v) =>
        (v && v.length <= 50) || i18n.t('message.maximumLength'),
      minLength: (v) => (v && v.length > 2) || i18n.t('message.minimumLength'),
    },
    fetchingNewFolder: false,
    oldFolderId: '',
  }),
  computed: {
    ...mapState('user', {
      userPlanInfo: 'userPlanInfo',
      folders: 'mainFolders',
      allFolders: 'allFolders',
    }),
    toBeSelectedFolders() {
      let selectedFolders = this.folders.filter((folder) => {
        return folder.parent_folder_id === this.lastFolder.id
      })
      let itemsThatAreFolders = this.movedItems.filter((movedItem) => {
        return movedItem.name
      })
      for (let folderItem of itemsThatAreFolders) {
        let foundItem = selectedFolders.find((item) => {
          return item.id === folderItem.id
        })
        if (foundItem) {
          let filtered = selectedFolders.filter(
            (item) => item.id !== folderItem.id
          )
          selectedFolders = [...filtered]
        }
      }
      return selectedFolders
    },
    isNamesTooBig() {
      let size = 0
      for (let folder of this.breadcrumbArray) {
        size += folder.name.length
      }
      if (this.selectedFolder?.name) {
        size += this.selectedFolder.name.length
      }
      return size > 40
    },
    lastBreadcrumbItem() {
      return this.breadcrumbArray[this.breadcrumbArray.length - 1]
    },
    reducedBreadcrumbArray() {
      let arrayMod = this.breadcrumbArray.filter((folder) => {
        return folder.id !== this.lastFolder.id
      })
      if (this.selectedFolder) {
        return this.breadcrumbArray
      }
      return arrayMod
    },
  },
  mounted() {
    this.$root.$on('restoreModal', (items, isCallback) => {
      Object.assign(this.$data, this.initialState())
      if (isCallback) this.isCallback = true
      this.items = items
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('folderModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR', 'UPDATE_MAIN_FOLDERS']),
    ...mapActions('user', ['editFolder', 'addFolder']),
    handleConfirmFolder() {
      let confirmedFolder = this.selectedFolder ?? this.lastFolder
      this.folder = confirmedFolder
      this.handleBackToMainContent()
    },
    handleBackToMainContent() {
      this.lastClickedItem = null
      this.isAlreadyClicked = false
      this.alreadyClickedTimeout = null
      this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
      this.newFolder = {
        name: '',
      }
      this.selectFolder = false
      this.showMainModalContent = true
    },
    handleSelectFolder() {
      this.selectFolder = true
      this.showMainModalContent = false
    },
    async handleRestoreItems() {
      let videos = []
      let folders = []
      for (let item of this.items) {
        if (item.title) {
          videos.push(item)
        }
        if (item.name) {
          folders.push(item)
        }
      }
      this.isFetching = true
      for (let folder of folders) {
        await this.handleRestoreFolders(folder)
      }
      await this.handleRestoreVideos(videos)
      this.isFetching = false
      this.handleClose()
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.restoreSuccess'),
        type: 'success',
      })
    },
    async handleRestoreFolders(folder) {
      try {
        await foldersApi.recoverDeletedFolder(folder.id)
        this.checkAndMoveIfNeeded(folder)
        this.$root.$emit('trashRemoveFolder', folder)
      } catch (e) {
        console.error(e)
      }
    },
    async handleRestoreVideos(videos) {
      let videoIds = videos.map((video) => ({ video_id: video.id }))
      if (!videos.length) return
      try {
        await videosApi.recoverDeletedVideo(videoIds)
        for (let video of videos) {
          this.checkAndMoveIfNeeded(video)
        }
        this.$root.$emit('trashRemoveVideos', videos)
      } catch (e) {
        console.error(e)
      }
    },
    async checkAndMoveIfNeeded(item) {
      let parentFolderId = ''
      let isFolder = !!item.name
      isFolder
        ? (parentFolderId = item.parent_folder_id)
        : (parentFolderId = item.folder_id)
      if (parentFolderId) {
        let foundParentFolder = this.allFolders.find(
          (folder) => folder.id === parentFolderId
        )
        if (foundParentFolder && foundParentFolder.status === false) {
          isFolder ? this.moveFolderToRoot(item) : this.moveVideoToRoot(item)
        }
      }
    },
    async moveVideoToRoot(video) {
      let videos = [{ video_id: video.id, folder_id: null }]
      try {
        const ret = await videosApi.updateMultipleVideos(videos)
        let updatedVideos = []
        if (videos.length < 2) {
          updatedVideos.push(ret.data)
        } else {
          updatedVideos = ret.data
        }
        this.$root.$emit('trashMovedRemovedVideos', updatedVideos)
      } catch (e) {
        console.error(e)
      }
    },
    async moveFolderToRoot(folder) {
      try {
        let ret = await foldersApi.updateFolder(
          { parent_folder_id: null },
          folder.id
        )
        this.editFolder(ret.data)
      } catch (e) {
        console.error(e)
      }
    },
    handleBackFolder() {
      if (this.lastFolder.parent_folder_id === null) {
        this.lastFolder = {
          name: '',
          id: null,
          parent_folder_id: null,
        }
        return
      }
      let parentFolder = this.folders.find(
        (folder) => folder.id === this.lastFolder.parent_folder_id
      )
      this.lastFolder = parentFolder
    },
    handleBackTo(backToFolder) {
      this.selectedFolder = null
      this.lastFolder = backToFolder
      if (!backToFolder.id) {
        this.breadcrumbArray = [{ name: '', id: null, parent_folder_id: null }]
        return
      }
      if (
        this.breadcrumbArray.length < 2 ||
        this.breadcrumbArray[this.breadcrumbArray.length - 1].id ===
          backToFolder.id
      )
        return
      let index = this.breadcrumbArray.findIndex((folder) => {
        return folder.id === backToFolder.id
      })
      let newArr = this.breadcrumbArray.slice(0, index + 1)
      this.breadcrumbArray = newArr
    },
    handleRowClick(item) {
      let hasChildren = this.checkIfHasChildren(item)
      if (hasChildren) return this.handleEnterFolder(item)
    },
    handleEnterFolder(folder) {
      this.lastFolder = folder
      this.breadcrumbArray.push(folder)
    },
    handleClose() {
      this.open = false
    },
    async handleNewFolder() {
      this.fetchingNewFolder = true
      let folderObject = {
        name: this.newFolder.name.trim(),
      }
      if (this.lastFolder.id) {
        folderObject['parent_folder_id'] = this.lastFolder.id
      }
      try {
        let ret = await foldersApi.createFolder(folderObject)
        this.addFolder(ret.data)
      } catch (e) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: `${e}`,
        })
      }
      this.fetchingNewFolder = false
      this.newFolderMenu = false
    },
    checkIfHasChildren(folder) {
      let anySon = this.folders.find(
        (item) => item.parent_folder_id === folder.id
      )
      return anySon
    },
    findFolderById(id) {
      return this.folders.find((folder) => {
        return folder.id === id
      })
    },
    getFolderPath(folder) {
      let theFolder = this.findFolderById(folder.id)
      let folderArray = [theFolder]
      let searchMoreFolders = true
      do {
        let folder = folderArray[folderArray.length - 1]
        if (folder.parent_folder_id) {
          let parentFolderId = folder.parent_folder_id
          let parentFolder = this.findFolderById(parentFolderId)
          folderArray.push(parentFolder)
        } else {
          searchMoreFolders = false
        }
      } while (searchMoreFolders)
      folderArray = folderArray.map((folder) => folder.name)
      folderArray.push('')
      folderArray = folderArray.reverse()
      let folderPathString = folderArray.join('/')
      return folderPathString
    },
    initialState() {
      return {
        open: false,
        isFetching: false,
        items: [],
        isCallback: false,
        folder: {
          id: null,
          name: '',
        },
        showMainModalContent: true,
        selectFolder: false,
        movedItems: [],
        breadcrumbArray: [{ name: '', id: null, parent_folder_id: null }],
        selectedFolder: null,
        lastFolder: {
          name: '',
          id: null,
          parent_folder_id: null,
        },
        newFolderMenu: false,
        newFolder: {
          name: '',
        },
        valid: false,
        rules: {
          required: (v) => (v && !!v) || i18n.t('message.requiredField'),
          maxLength: (v) =>
            (v && v.length <= 50) || i18n.t('message.maximumLength'),
          minLength: (v) =>
            (v && v.length > 2) || i18n.t('message.minimumLength'),
        },
        fetchingNewFolder: false,
        oldFolderId: '',
      }
    },
  },
}
</script>

<style scoped lang="scss">
.restoreModalTitle {
  color: varFigma(neutral-20-dark);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 21.6px */
}

.restoreModalDescription {
  color: varFigma(neutral-40-light);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}
</style>

<style>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.folderPath {
  word-break: break-all;
}
</style>
